import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useParams } from 'react-router-dom';
import { find } from 'lodash';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import useStaticProductCardData from 'hooks/useStaticProductCardData';
import LivestreamActiveVideo from './components/LivestreamActiveVideo';
import LivestreamLatestVideos from './components/LivestreamLatestVideos';
import LiveVideoPlayingBanner from './components/LiveVideoPlayingBanner';
const LivestreamPageUI = t0 => {
  const $ = _c(34);
  const {
    isAdmin: t1,
    videos,
    videoCategories: t2,
    videoStreamingLive,
    loadMoreVideos,
    hasMoreVideos
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const videoCategories = t3;
  const [selectedVideo, setSelectedVideo] = useState();
  const wrapperRef = useRef(null);
  const {
    slug
  } = useParams();
  let t4;
  if ($[2] !== videos) {
    t4 = videos?.map(_temp2)?.flat(1);
    $[2] = videos;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const productIds = t4;
  let t5;
  if ($[4] !== productIds) {
    t5 = {
      productIds
    };
    $[4] = productIds;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    products: allProducts
  } = useStaticProductCardData(t5);
  let t6;
  if ($[6] !== allProducts || $[7] !== selectedVideo?.skuBuilder) {
    t6 = () => {
      const productIdsForSelectedVideo = selectedVideo?.skuBuilder.map(_temp3);
      const finalProducts = allProducts?.filter(t7 => {
        const {
          id
        } = t7;
        return productIdsForSelectedVideo?.includes(id);
      });
      return finalProducts;
    };
    $[6] = allProducts;
    $[7] = selectedVideo?.skuBuilder;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  selectedVideo?.skuBuilder;
  let t7;
  if ($[9] !== t6) {
    t7 = t6();
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const productsForSelectedVideo = t7;
  let t8;
  let t9;
  if ($[11] !== slug || $[12] !== videos) {
    t8 = () => {
      if (videos) {
        if (slug) {
          const currentVideo = find(videos, {
            slug
          });
          setSelectedVideo(currentVideo);
        } else {
          setSelectedVideo(videos[0]);
        }
      }
    };
    t9 = [slug, videos];
    $[11] = slug;
    $[12] = videos;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  useEffect(t8, t9);
  let t10;
  if ($[15] !== isAdmin || $[16] !== productsForSelectedVideo || $[17] !== selectedVideo) {
    t10 = !!selectedVideo && <FixedWidthContainer className="!pt-14" noMobilePadding={true} noTabletPadding={true}><LivestreamActiveVideo category={selectedVideo.category} description={selectedVideo.description} isPlayingLive={selectedVideo.isPlayingLive} products={productsForSelectedVideo} title={selectedVideo.title} videoId={selectedVideo.videoId} videoType={selectedVideo.videoType} isAdmin={isAdmin} /></FixedWidthContainer>;
    $[15] = isAdmin;
    $[16] = productsForSelectedVideo;
    $[17] = selectedVideo;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== hasMoreVideos || $[20] !== loadMoreVideos || $[21] !== selectedVideo || $[22] !== videoCategories || $[23] !== videos) {
    t11 = !!videos && <InfiniteScroll dataLength={videos ? videos.length : 0} next={loadMoreVideos} hasMore={hasMoreVideos} key={`${videos.length}-video-grid`} loader={<div>Loading...</div>} scrollThreshold={0.53}><LivestreamLatestVideos selectedVideo={selectedVideo ? {
        videoId: selectedVideo.videoId,
        videoType: selectedVideo.videoType
      } : null} videoCategories={videoCategories} videos={videos.map(video_0 => ({
        ...video_0,
        isSelected: selectedVideo && selectedVideo.videoType === video_0.videoType && selectedVideo.videoId === video_0.videoId
      }))} /></InfiniteScroll>;
    $[19] = hasMoreVideos;
    $[20] = loadMoreVideos;
    $[21] = selectedVideo;
    $[22] = videoCategories;
    $[23] = videos;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <FixedWidthContainer>{t11}</FixedWidthContainer>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== selectedVideo || $[28] !== videoStreamingLive) {
    t13 = !!videoStreamingLive && selectedVideo && videoStreamingLive.videoId !== selectedVideo.videoId && selectedVideo.videoId !== "vimeo" && <LiveVideoPlayingBanner videoStreamingLive={videoStreamingLive} category={videoStreamingLive.category} title={videoStreamingLive.title} slug={videoStreamingLive?.slugs} />;
    $[27] = selectedVideo;
    $[28] = videoStreamingLive;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t12 || $[32] !== t13) {
    t14 = <div className="[&_.infinite-scroll-component]:!overflow-x-hidden" ref={wrapperRef}>{t10}{t12}{t13}</div>;
    $[30] = t10;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};
LivestreamPageUI.propTypes = {
  isAdmin: PropTypes.bool,
  videoCategories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string
  })),
  videos: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    categories: PropTypes.array,
    image: PropTypes.string,
    isRecordedLive: PropTypes.bool,
    products: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
    videoId: PropTypes.string,
    videoLength: PropTypes.string,
    videoType: PropTypes.oneOf(['vimeo', 'wistia'])
  })),
  videoStreamingLive: PropTypes.shape({
    category: PropTypes.string,
    description: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
    videoId: PropTypes.string,
    slugs: PropTypes.string
  }),
  loadMoreVideos: PropTypes.func,
  hasMoreVideos: PropTypes.bool
};
export default LivestreamPageUI;
function _temp(product) {
  return product?.id;
}
function _temp2(video) {
  return video?.skuBuilder?.map(_temp);
}
function _temp3(product_0) {
  return product_0?.id;
}